module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-180x180-551c4bb61c140caf1fc35ee3ed524eca.png";